/**
 * Physio Calendar Service
 *
 * Handles all physio availability and appointment-related API calls
 */

import { HTTP } from "./http";

let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-player-Injury.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-player-Injury.php";
}

const PhysioCalendarService = {
  /**
   * Get all physios in the club
   * @param {string} clubId
   */
  getAllPhysios(clubId) {
    return HTTP.post(API_SERVER, {
      action: 'getAllPhysios',
      clubId
    });
  },

  /**
   * Get physio availability for a date range
   * @param {object} params - { physio_id, week_start, week_end? }
   */
  getAvailability(params) {
    return HTTP.post(API_SERVER, {
      action: 'getPhysioAvailability',
      ...params
    });
  },

  /**
   * Add a single availability slot
   * @param {object} data - { physio_id, date, start_time, end_time, slot_length_minutes }
   */
  addAvailability(data) {
    return HTTP.post(API_SERVER, {
      action: 'addAvailability',
      ...data
    });
  },

  /**
   * Remove a single availability slot
   * @param {object} data - { physio_id, date, start_time }
   */
  removeAvailability(data) {
    return HTTP.post(API_SERVER, {
      action: 'removeAvailability',
      ...data
    });
  },

  /**
   * Bulk remove availability slots
   * @param {object} data - { physio_id, start_date?, end_date?, date? }
   */
  bulkRemoveAvailability(data) {
    return HTTP.post(API_SERVER, {
      action: 'bulkRemoveAvailability',
      ...data
    });
  },

  /**
   * Get appointments for a physio
   * @param {object} params - { physio_id, week_start, week_end? }
   */
  getAppointments(params) {
    return HTTP.post(API_SERVER, {
      action: 'getAppointments',
      ...params
    });
  },

  /**
   * Get appointments for a player
   * @param {object} params - { player_id, upcoming_only?, start_date?, end_date? }
   */
  getPlayerAppointments(params) {
    return HTTP.post(API_SERVER, {
      action: 'getPlayerAppointments',
      ...params
    });
  },

  /**
   * Book an appointment slot
   * @param {object} data - { physio_id, player_id, date, start_time, end_time, reason?, notes? }
   */
  bookSlot(data) {
    return HTTP.post(API_SERVER, {
      action: 'bookSlot',
      ...data
    });
  },

  /**
   * Cancel an appointment
   * @param {object} data - { appointment_id, user_id, user_type, send_notification? }
   */
  cancelAppointment(data) {
    return HTTP.post(API_SERVER, {
      action: 'cancelAppointment',
      ...data
    });
  },

  /**
   * Update an appointment (notes, reschedule)
   * @param {object} data - { appointment_id, notes?, reason?, status?, new_date?, new_start_time?, new_end_time? }
   */
  updateAppointment(data) {
    return HTTP.post(API_SERVER, {
      action: 'updateAppointment',
      ...data
    });
  },

  /**
   * Format time for display (e.g., "09:00" -> "9:00 AM")
   * @param {string} time - HH:MM format
   * @returns {string}
   */
  formatTime(time) {
    if (!time) return '';
    const parts = time.split(':');
    const hour = parseInt(parts[0], 10);
    const min = parts[1];
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return displayHour + ':' + min + ' ' + ampm;
  }
};

export { PhysioCalendarService };
export default PhysioCalendarService;
